module.exports = __webpack_public_path__ + "img/sample16.e33fa455.jpg";